// import { AlarmClock, ChevronDown } from "lucide-react";
import type { CSSProperties } from "react";

export const options = [
  { id: 'under_review', value: 'Under Univ Diam Review', label: 'Under Univ Diam Review', bgColor: '#5C6BC030', borderColor: '#5C6BC0' },
  { id: 'quote_in_progress_new', value: 'Quote in Progress - NEW', label: 'CAD/Quote in Progress - NEW', bgColor: '#FFDB4330', borderColor: '#FFDB43' },
  { id: 'quote_in_progress_revision', value: 'Quote in Progress - REVISION', label: 'CAD/Quote in Progress - REVISION', bgColor: '#FFDB4330', borderColor: '#FFDB43' },
  { id: 'waiting_for_approval', value: 'Waiting for Client Approval', label: 'Waiting for Client Approval', bgColor: '#FB823730', borderColor: '#FB8237' },
  { id: 'cad_archive', value: 'CAD Archive', label: 'CAD Archive', bgColor: '#60A5FA30', borderColor: '#60A5FA' },
  { id: 'in_manufacturing', value: 'In Manufacturing', label: 'In Manufacturing', bgColor: '#FFDB4330', borderColor: '#FFDB43' },
  { id: 'ready_at_facility', value: 'Ready at MRF Facility', label: 'Ready at MRF Facility', bgColor: '#FFDB4330', borderColor: '#FFDB43' },
  { id: 'in_transit_to_univ_diam_usa', value: 'In Transit to Univ Diam USA', label: 'In Transit to Univ Diam USA', bgColor: '#FFDB4330', borderColor: '#FFDB43' },
  { id: 'final_setting_finishing_usa', value: 'Final Setting/Finishing USA', label: 'Final Setting/Finishing USA', bgColor: '#FFDB4330', borderColor: '#FFDB43' },
  { id: 'ready_to_deliver', value: 'Ready to Deliver', label: 'Ready to Deliver', bgColor: '#FFDB4330', borderColor: '#FFDB43' },
  // { id: 'invoice_review', value: 'Invoice Review', label: 'Invoice Review', bgColor: '#00B878', borderColor: '#00B878' },
  { id: 'completed', value: 'Completed', label: 'Completed / Invoice Review', bgColor: '#00B87830', borderColor: '#00B878' },
  { id: 'completed_archive', value: 'Completed Archive', label: 'Completed Archive', bgColor: '#6B728030', borderColor: '#6B7280' },
];

/** Neutral chip for a status that isn't in the vocabulary (free-text entries). */
const NEUTRAL = { bgColor: '#6B728030', borderColor: '#6B7280' };

/**
 * Look up a stored status against the vocabulary. Surfaces disagree on what
 * they persist -- the order status dropdown stores `id`, while free-text
 * surfaces (shipment tracking) store the human `value` -- so match on any of
 * the three. Case/whitespace insensitive.
 */
export function findStatusOption(status?: string | null) {
  if (!status) return undefined;
  const key = status.trim().toLowerCase();
  return options.find(
    opt =>
      opt.id.toLowerCase() === key ||
      opt.value.toLowerCase() === key ||
      opt.label.toLowerCase() === key
  );
}

/**
 * Chip fill + border for a status string, in the same tint convention as the
 * vocabulary above (hue at 30 alpha behind its full-strength border). Falls
 * back to a neutral grey chip so a free-text status is still a visible shape,
 * the way `labelStyle` handles custom labels.
 */
export function statusChipStyle(status?: string | null): CSSProperties {
  const match = findStatusOption(status) ?? NEUTRAL;
  return { backgroundColor: match.bgColor, borderColor: match.borderColor };
}

/** Label to show for a stored status: the vocabulary's, or the raw text. */
export function statusLabel(status?: string | null): string {
  return findStatusOption(status)?.label ?? (status ?? '').trim();
}


{/*
  
  
import React from "react"
import { type ColumnDef } from "@tanstack/react-table"
import { ArrowUpDown, FileSearch, Loader, FileText, CheckCircle, Truck, Package, Edit, DollarSign, Check } from 'lucide-react'
import { Button } from "../../components/button"
import { Badge } from "../../components/badge"
import TagsCell from "./TagsCell"

export type OrderList = {
  id: string;
  customer_id: number;
  order_id: string;
  job_title: string;
  product_type: string;
  product_name: string;
  quantity: number;
  size: string;
  metal_type: string;
  special_instructions: string;
  media_attachment: string[];
  resin_sample_model: number;
  is_draft: number;
  status: string;
  labels: string[];
  order_type: string;
  is_new_update: number;
  created_at: string;
  updated_at: string;
  column: string;
}

const statusMap = {
  under_review: {
    label: 'Under Review',
    bgColor: '#5C6BC030',
    borderColor: '#5C6BC0',
    icon: <FileSearch className="fill-green-500 dark:fill-green-400" />
  },
  quote_in_progress: {
    label: 'Quote in Progress',
    bgColor: '#FFDB4330',
    borderColor: '#FFDB43',
    icon: <FileText className="fill-yellow-500 dark:fill-yellow-400" />
  },
  waiting_for_approval: {
    label: 'Waiting for Client Approval',
    bgColor: '#FB823730',
    borderColor: '#FB8237',
    icon: <CheckCircle className="fill-orange-500 dark:fill-orange-400" />
  },
  in_manufacturing: {
    label: 'In Manufacturing',
    bgColor: '#FFDB4330',
    borderColor: '#FFDB43',
    icon: <Package className="fill-yellow-500 dark:fill-yellow-400" />
  },
  ready_at_facility: {
    label: 'Ready at Facility',
    bgColor: '#FFDB4330',
    borderColor: '#FFDB43',
    icon: <Truck className="fill-blue-500 dark:fill-blue-400" />
  },
  in_transit_to_univ_diam_usa: {
    label: 'In Transit to Univ Diam USA',
    bgColor: '#FFDB4330',
    borderColor: '#FFDB43',
    icon: <Truck className="fill-blue-500 dark:fill-blue-400" />
  },
  ready_to_deliver: {
    label: 'Ready to Deliver',
    bgColor: '#FFDB4330',
    borderColor: '#FFDB43',
    icon: <Check className="fill-green-500 dark:fill-green-400" />
  },
  invoice_review: {
    label: 'Invoice Review',
    bgColor: '#00B878',
    borderColor: '#00B878',
    icon: <DollarSign className="fill-green-500 dark:fill-green-400" />
  },
  completed: {
    label: 'Completed',
    bgColor: '#00B878',
    borderColor: '#00B878',
    icon: <CheckCircle className="fill-green-500 dark:fill-green-400" />
  }
};

export const columns: ColumnDef<OrderList>[] = [
  {
    accessorKey: "labels",
    header: "Labels",
    enableColumnFilter: true,
    cell: ({ row }) => (
      <TagsCell
        labels={row.original.labels}
        orderId={row.original.order_id}
        newUpdate={Boolean(row.original.is_new_update)}
      />
    )
  },
  {
    accessorKey: "order_id",
    header: "Order ID",
  },
  {
    accessorKey: "job_title",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          className="!p-0"
        >
          Job Title
          <ArrowUpDown />
        </Button>
      )
    },
    enableColumnFilter: true,
  },
  {
    accessorKey: "product_type",
    enableColumnFilter: true,
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          className="!p-0"
        >
          Type of Jewelry
          <ArrowUpDown />
        </Button>
      )
    },
  },
  {
    accessorKey: "created_at",
    header: "Date of Creation",
  },
  {
    accessorKey: "resin_sample_model",
    header: "Resin Sample Model",
    cell: ({ row }) => {
      const resinSample = row.original.resin_sample_model;
      return <span>{resinSample === 1 ? 'Provide sample' : 'None'}</span>;
    }
  },
  {
    accessorKey: "metal_type",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          className="!p-0"
        >
          Metal Type
          <ArrowUpDown />
        </Button>
      )
    },
    enableColumnFilter: true,
  },
  {
    accessorKey: "size",
    header: "Size",
  },
  {
    accessorKey: "quantity",
    header: "Quantity",
    cell: ({ row }) => (
      <span>{row.original.quantity} pcs</span>
    )
  },
  {
    accessorKey: "status",
    header: "Status",
    enableColumnFilter: true,
    cell: ({ row }) => {
      const status = row.original.status;
      const statusInfo = statusMap[status] || {}; // Default to empty object if status is not found

      return (
        <Badge
          variant="outline"
          className="text-muted-foreground px-1.5"
          style={{
            backgroundColor: statusInfo.bgColor,
            borderColor: statusInfo.borderColor
          }}
        >
          {statusInfo.icon}
          {statusInfo.label}
        </Badge>
      )
    },
  },
  {
    accessorKey: "order_type",
    header: "Order Type",
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return (
        <Button variant="ghost" className="h-8 w-8 p-0">
          <span className="sr-only">Open menu</span>
          <Edit size={16} strokeWidth={1} className="h-4 w-4" />
        </Button>
      )
    },
  },
]

  
  
*/}